// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-form-section {
    max-width: 900px;
}

.blog-form {
    max-width: 100% !important;
}

.file-input {
    padding: 6px 0;
    font-size: 13px;
}

.image-size-hint {
    display: block;
    font-size: 11px;
    color: #6b7280;
    margin-bottom: 4px;
}

.upload-status {
    display: block;
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
}

.image-preview {
    display: block;
    margin-top: 8px;
    max-width: 200px;
    max-height: 120px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #d1d5db;
}

.blog-editor {
    min-height: 320px;
}

.blog-editor .ql-container {
    min-height: 280px;
    font-size: 14px;
}

.editor-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}

.editor-label-row .form-label {
    margin-bottom: 0;
}

.source-toggle-btn {
    background: none;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 3px 10px;
    font-size: 12px;
    cursor: pointer;
    color: #374151;
}

.source-toggle-btn:hover {
    background-color: #f3f4f6;
}

.source-code-area {
    min-height: 320px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.5;
    resize: vertical;
}

.blog-form .form-actions {
    margin-top: 48px;
    padding-top: 24px;
    border-top: 1px solid #e5e7eb;
    position: relative;
    z-index: 0;
}

.form-error {
    color: #dc2626;
    font-size: 13px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background-color: #fef2f2;
    border-radius: 4px;
    border: 1px solid #fecaca;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BlogForm/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".blog-form-section {\n    max-width: 900px;\n}\n\n.blog-form {\n    max-width: 100% !important;\n}\n\n.file-input {\n    padding: 6px 0;\n    font-size: 13px;\n}\n\n.image-size-hint {\n    display: block;\n    font-size: 11px;\n    color: #6b7280;\n    margin-bottom: 4px;\n}\n\n.upload-status {\n    display: block;\n    font-size: 12px;\n    color: #6b7280;\n    margin-top: 4px;\n}\n\n.image-preview {\n    display: block;\n    margin-top: 8px;\n    max-width: 200px;\n    max-height: 120px;\n    object-fit: cover;\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n}\n\n.blog-editor {\n    min-height: 320px;\n}\n\n.blog-editor .ql-container {\n    min-height: 280px;\n    font-size: 14px;\n}\n\n.editor-label-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 6px;\n}\n\n.editor-label-row .form-label {\n    margin-bottom: 0;\n}\n\n.source-toggle-btn {\n    background: none;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    padding: 3px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    color: #374151;\n}\n\n.source-toggle-btn:hover {\n    background-color: #f3f4f6;\n}\n\n.source-code-area {\n    min-height: 320px;\n    font-family: 'Courier New', monospace;\n    font-size: 13px;\n    line-height: 1.5;\n    resize: vertical;\n}\n\n.blog-form .form-actions {\n    margin-top: 48px;\n    padding-top: 24px;\n    border-top: 1px solid #e5e7eb;\n    position: relative;\n    z-index: 0;\n}\n\n.form-error {\n    color: #dc2626;\n    font-size: 13px;\n    margin-bottom: 12px;\n    padding: 8px 12px;\n    background-color: #fef2f2;\n    border-radius: 4px;\n    border: 1px solid #fecaca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
